import { Outlet, createFileRoute } from '@tanstack/react-router'
import { DocsLayout } from '@/features/docs/components/DocsLayout'
import { generateMetaTags } from '@/lib/seo'

export const Route = createFileRoute('/docs')({
  // No `links`/canonical here — every child route (docs/index.tsx,
  // docs/$.tsx, docs/api-reference/*) sets its own canonical, and TanStack
  // Router's link merge doesn't dedupe by rel, so a canonical set here would
  // render alongside the child's, giving every /docs/* page two conflicting
  // canonical tags.
  head: () => ({
    meta: generateMetaTags({
      title: 'Documentation - ModelStack',
      description:
        'Complete documentation for ModelStack API - guides, API reference, SDKs, and integrations.',
      keywords: [
        'modelstack docs',
        'api documentation',
        'ai api guide',
        'openai compatible',
      ],
    }),
  }),
  component: DocsLayoutRoute,
})

function DocsLayoutRoute() {
  return (
    <DocsLayout>
      <Outlet />
    </DocsLayout>
  )
}
